import React from "react";
import { Fade, Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useThemeMediaQuery from "@fuse/hooks/useThemeMediaQuery";
import { useDispatch } from "react-redux";
const spanStyle = {
  padding: "20px",
  background: "#efefef",
  color: "#000000",
};

const divStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundSize: "cover",
  height: "400px",
};
export default function ProductImageViewer(props) {
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(props.open);
  const [slideImages, setSlideImages] = React.useState(props.imagesData);

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  React.useEffect(() => {
    setSlideImages(props.imagesData);
  }, [props.imagesData]);

  const handleClose = () => {
    setOpen(false);
    props.handleProductImageViewerClose();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} className="sci-dialog">
        <DialogTitle>
          <Grid container justify="space-between" alignItems="center">
            <IconButton onClick={() => handleClose()}>
              <CloseIcon />
            </IconButton>
            <Typography variant="div" className="dialog-title">
              Product Images
            </Typography>
          </Grid>
        </DialogTitle>
        <DialogContent
          className={
            isMobile
              ? "mobile-create-job-dialog-content"
              : "web-create-job-dialog-content"
          }
        >
          <Slide autoplay={false}>
            {slideImages.map((slideImage, index) => (
              <div key={index}>
                <div
                  style={{
                    ...divStyle,
                    backgroundImage: `url(${slideImage.image_url})`,
                  }}
                  className="each-slide-effect"
                >
                  {/* <span style={spanStyle}>{slideImage.caption}</span> */}
                </div>
              </div>
            ))}
          </Slide>
        </DialogContent>
      </Dialog>
    </div>
  );
}
